import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const PieIcon = createIcon(
  'Pie',
  <path d="M12.9,3 L12.9,5.73383459 C15.951,6.17593985 18.3,8.7924812 18.3,11.9774436 C18.3,12.7894737 18.138,13.556391 17.868,14.2691729 L20.208,15.6496241 C20.712,14.5308271 21,13.2857143 21,11.9774436 C21,7.3037594 17.445,3.45112782 12.9,3 Z M12,18.2932331 C8.517,18.2932331 5.7,15.4691729 5.7,11.9774436 C5.7,8.7924812 8.049,6.17593985 11.1,5.73383459 L11.1,3 C6.546,3.45112782 3,7.29473684 3,11.9774436 C3,16.9578947 7.023,21 11.991,21 C14.97,21 17.607,19.5473684 19.245,17.3097744 L16.905,15.9293233 C15.753,17.3729323 13.989,18.2932331 12,18.2932331 Z" />
);

export default PieIcon;
